// YouTubeとVimeoのiframeを見つけたら、画面に表示されたときにautoplayを有効にする
document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const iframe = entry.target

          // iframe.srcが存在しない場合はスキップ
          if (!iframe.src) {
            return
          }

          // YouTubeの処理
          if (isYouTubeIframe(iframe.src)) {
            enableYouTubeAutoplay(iframe)
          }

          // Vimeoの処理
          if (isVimeoIframe(iframe.src)) {
            enableVimeoAutoplay(iframe)
          }

          // 一度表示されたら監視を停止
          observer.unobserve(iframe)
        }
      })
    },
    {
      threshold: 0.1, // 10%表示されたら発火
    }
  )

  // すべてのiframeを監視対象に追加
  document.querySelectorAll('iframe').forEach((iframe) => {
    // .youtube_channel_playerクラスがついているiframeは対象外
    if (iframe.classList.contains('youtube_channel_player')) {
      return
    }

    if (iframe.src && (isYouTubeIframe(iframe.src) || isVimeoIframe(iframe.src))) {
      observer.observe(iframe)
    }
  })
})

// YouTubeのiframeかどうかを判定
function isYouTubeIframe(src) {
  return src.includes('youtube.com') || src.includes('youtube-nocookie.com')
}

// Vimeoのiframeかどうかを判定
function isVimeoIframe(src) {
  return src.includes('vimeo.com')
}

// YouTubeのautoplayを有効にする
function enableYouTubeAutoplay(iframe) {
  // 既にautoplayが設定されているかチェック
  if (iframe.src.includes('autoplay=1')) {
    return
  }

  iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture')

  // URLパラメータを安全に追加
  const separator = iframe.src.includes('?') ? '&' : '?'
  iframe.src += `${separator}autoplay=1&mute=1`
}

// Vimeoのautoplayを有効にする
function enableVimeoAutoplay(iframe) {
  // 既にautoplayが設定されているかチェック
  if (iframe.src.includes('autoplay=1')) {
    return
  }

  // URLパラメータを安全に追加
  const separator = iframe.src.includes('?') ? '&' : '?'
  iframe.src += `${separator}autoplay=1&muted=1`
}
